import React, { useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const FluidTracedImage = ({ path, ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { internal: { mediaType: { regex: "/image/" } } }) {
        nodes {
          relativePath
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  `)

  const match = useMemo(
    () => data.allFile.nodes.find(({ relativePath }) => relativePath === path),
    [data, path]
  )

  if (match?.childImageSharp?.fluid == null) {
    return null
  }

  return <Img fluid={match.childImageSharp.fluid} {...props} />
}

export default FluidTracedImage
